import { inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as configurationProfileActions from './config-profile.actions';
import * as profileSelectors from './config-profile.selectors';
import * as _operatorsActions from '../../../store/operators/operators.actions';
import * as operatorsSelectors from '../../../store/operators/operators.selectors';
import { catchError, map, of, switchMap, tap } from 'rxjs';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { MessageTranslateService } from '../../../shared/services/message.service';
import { DefaultPageSize } from '../../../shared/constants/pagination.constants';
import * as operatorsActions from '../../../store/operators/operators.actions';
import { ConfigurationProfileService } from '../services/configuration-profile.service';

export class ConfigurationProfileEffects {
  actions$: Actions = inject(Actions);
  profileService = inject(ConfigurationProfileService);
  store: Store = inject(Store);
  messageService = inject(MessageTranslateService);

  loadConfigurationProfiles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(
        configurationProfileActions.loadConfigurationProfileList,
        configurationProfileActions.changeConfigurationProfilePaginationSuccessful,
        configurationProfileActions.insertNewConfigurationProfileSuccess,
        configurationProfileActions.deleteNewConfigurationProfileSuccess,
        configurationProfileActions.updateConfigurationProfileSuccess,
        operatorsActions.SetCurrentOperatorSuccess
      ),
      concatLatestFrom(() => [
        this.store.select(operatorsSelectors.selectCurrentOperator),
        this.store.select(profileSelectors.selectProfilesPagination),
      ]),
      switchMap(([_action, selectedOperator, pagination]) =>
        this.profileService
          .searchProfiles(
            selectedOperator!.id!,
            pagination?.pageSize ?? DefaultPageSize,
            pagination?.pageIndex ?? 0
          )
          .pipe(
            map((res) => {
              if (res.isSuccess) {
                return configurationProfileActions.loadConfigurationProfileListSuccess({
                  pagedResponse: res.value!,
                });
              } else {
                return configurationProfileActions.loadConfigurationProfileListFailure({
                  error: res.error!,
                });
              }
            }),
            catchError((err) =>
              of(
                configurationProfileActions.loadConfigurationProfileListFailure({
                  error: err.message || 'Loading Configuration Profiles failed',
                })
              )
            )
          )
      )
    )
  );

  deleteConfigurationProfile$ = createEffect(() =>
    this.actions$.pipe(
      ofType(configurationProfileActions.deleteNewConfigurationProfile),
      switchMap((requestData) =>
        this.profileService.deleteProfile(requestData.configurationProfileId).pipe(
          map((res) => {
            if (res.isSuccess) {
              return configurationProfileActions.deleteNewConfigurationProfileSuccess({
                result: res,
              });
            }
            return configurationProfileActions.deleteNewConfigurationProfileFailure({
              error: res.error!,
            });
          })
        )
      )
    )
  );

  onUpsertError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(
          configurationProfileActions.insertNewConfigurationProfileFailure,
        ),
        tap((err) =>
          err.error
            ? this.messageService.error(err.error)
            : this.messageService.errorTranslate('configurationProfiles.failed-to-save')
        )
      ),
    { dispatch: false }
  );
}
